'use strict';

var DnsLookup = require('actionGroups/dnsLookup/DnsLookup');

module.exports = {
  Model: DnsLookup,
};
